import React from "react";
import ApiRequest from "./common/restservice";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";

export default class Pan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MemberID: "",
      FullName: "",
      panoraadhar: true,
      number: "",
      status: ""
    }
  }
  componentDidMount() {
    this.setState({
      panoraadhar: window.location.href.includes("pan")
    })
    this.GetDashboardDetails();
  }
  UNSAFE_componentWillReceiveProps() {
    this.setState({
      panoraadhar: window.location.href.includes("pan")
    })
    this.GetDashboardDetails();
  }
  async GetDashboardDetails() {
    let res = await ApiRequest("MyProfile.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      MemberID: res.MemberID,
      FullName: res.FullName,
      number: this.state.panoraadhar ? res.Pan : res.aadhar,
      status: this.state.panoraadhar ? res.pan_approve : res.aadhar_approve
    });
  }
  render() {
    return (
      <div>
        <PageHeader title="Convert Wallet" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
            <div className="card overflow-hidden dash1-card border-0 ">
              <div className="card-body">
                <h3 className=" mt-3 mb-3 text-center">{this.state.panoraadhar ? "PAN" : "AADHAR"}</h3>
                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                  <tbody>
                    <tr>
                      <td>Username</td>
                      <td>
                        <h6>{this.state.MemberID}</h6>
                      </td>
                    </tr>
                    <tr>
                      <td className="mt-2">Fullname</td>
                      <td className="mt-2">
                        <h6>{this.state.FullName}</h6>
                      </td>
                    </tr>
                    <tr>
                      <td className="mt-2">{this.state.panoraadhar ? "Pan" : "Aadhar"} card</td>
                      <td className="mt-2">
                        <h6>{this.state.number}</h6>
                      </td>
                    </tr>
                    <tr>
                      <td className="mt-2">Status</td>
                      <td className="mt-2">
                        <button className={`btn ${this.state.status ? "btn-color-1" : "btn-color-2"}`}>{this.state.status ? "Approved" : "Pending"}</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}